"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _InterestBalancesTable = _interopRequireDefault(require("./InterestBalancesTable"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('activity');
var InterestBalancesComponent = function InterestBalancesComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('interest'),
    t = _useTranslation.t;
  var width = props.width,
    themeModifier = props.themeModifier,
    rates = props.rates;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('header-bar')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('header-text')
  }, t('Balances'))), /*#__PURE__*/_react["default"].createElement(_InterestBalancesTable["default"], {
    themeModifier: themeModifier,
    width: width,
    rates: rates
  }));
};
var _default = exports["default"] = InterestBalancesComponent;